document.addEventListener("DOMContentLoaded", (event) => {
	let ootms = document.querySelectorAll(".vb-ootm") as NodeListOf<HTMLElement>;
	let active = document.querySelector(".vb-ootm.vb--active") as HTMLElement;
	let slug = window.sessionStorage["vb-ootm-slug"] as String;
	if (slug) {
		let target = Array.from(ootms).find(ootm => ootm.dataset.ootmSlug === slug);
		active.classList.remove("vb--active");
		target.classList.add("vb--active");
	} else {
		let target = ootms[Math.floor(Math.random() * ootms.length)];
		window.sessionStorage["vb-ootm-slug"] = target.dataset.ootmSlug;
		active.classList.remove("vb--active");
		target.classList.add("vb--active");
	}
});
